export default __webpack_public_path__ + "static/media/book-2.2434085f.svg";